import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

import { submitReturnShipping } from '../../api/apiReturns';
import parseError from '../../utils/parseError';

export const useSubmitReturnShipping = () => {
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, data }) => submitReturnShipping(id, data),
        onSuccess: (_, vars) => {
            toast.success(t('returns.shippingSaved', 'Shipping info saved'));
            queryClient.invalidateQueries({ queryKey: ['my-return', vars.id] });
            queryClient.invalidateQueries({ queryKey: ['my-returns'] });
        },
        onError: (err) => {
            toast.error(parseError(err) || t('returns.shippingError', 'Could not save shipping info'));
        },
    });
};

export default useSubmitReturnShipping;
